import { Application } from "@hotwired/stimulus";
import ProjectInstallWaitingController from "./controllers/project_install_waiting_controller";
import ProjectNameGeneratorController from "./controllers/project_name_generator_controller";
import NoticeTimelineController from "./controllers/notice_timeline_controller";
import DropdownController from "./controllers/dropdown";
import RevealController from "./controllers/reveal";
import ToggleController from "./controllers/toggle";
import NoticeVolumeTimelineController from "./controllers/notice_volume_timeline_controller";
import InsightsVolumeTimelineController from "./controllers/insights_volume_timeline_controller";
import DataUpdaterController from "./controllers/data_updater_controller";
import ComponentsController from "./controllers/components_controller";
import TableSorterController from "./controllers/table_sorter_controller";
import HorizontalBarChartController from "./controllers/horizontal_bar_chart_controller";
import TimelineLineChartController from "./controllers/timeline_line_chart_controller";
import ResponseTimeChartController from "./controllers/response_time_chart_controller";
import ChannelBacklogController from "./controllers/channel_backlog_controller";
import ChannelClickUpController from "./controllers/channel_click_up_controller";
import ChannelClickUpChatController from "./controllers/channel_click_up_chat_controller";
import SidebarController from "./controllers/sidebar_controller";
import ResponsiveNavController from "./controllers/responsive_nav_controller";
import CssUpdaterController from "./controllers/css_updater_controller";
import NoticePagerController from "./controllers/notice_pager_controller";
import MergeModalController from "./controllers/merge_modal_controller";
import AutoModalController from "./controllers/auto_modal_controller";
import ThemeSwitcherController from "./controllers/theme_switcher_controller";
import TabsController from "./controllers/tabs_controller";
import FaultHandsfree from "./controllers/fault_handsfree_controller";
import SiteHandsfree from "./controllers/site_handsfree_controller";
import DocsToggleController from "./controllers/docs_toggle_controller";
import PaymentCheckerController from "./controllers/payment_checker_controller";
import ChannelFormController from "./controllers/channel_form_controller";
import UnsavedChangesController from "./controllers/unsaved_changes_controller";
import FilterElementsController from "./controllers/filter_elements_controller";
import VisibleIfController from "./controllers/visible_if_controller";
import SearchableListController from "./controllers/searchable_list_controller";
import ClipboardController from "./controllers/clipboard_controller";
import SourceCodeController from "./controllers/source_code_controller";
import DismissibleController from "./controllers/dismissible_controller";
import BulkActionsController from "./controllers/bulk_actions_controller";
import MentionController from "./controllers/mention_controller";
import ParametersPopoverController from "./controllers/parameters_popover_controller";
import SourceEditorModalController from "./controllers/source_editor_modal_controller";

const Stimulus = Application.start();

Stimulus.register("project-install-waiting", ProjectInstallWaitingController);
Stimulus.register("project-name-generator", ProjectNameGeneratorController);
Stimulus.register("notice-timeline", NoticeTimelineController);
Stimulus.register("dropdown", DropdownController);
Stimulus.register("reveal", RevealController);
Stimulus.register("tabs", TabsController);
Stimulus.register("clipboard", ClipboardController);
Stimulus.register("toggle", ToggleController);
Stimulus.register("sidebar", SidebarController);
Stimulus.register("responsive-nav", ResponsiveNavController);
Stimulus.register("theme-switcher", ThemeSwitcherController);

Stimulus.register("notice-volume-timeline", NoticeVolumeTimelineController);
Stimulus.register("insights-volume-timeline", InsightsVolumeTimelineController);
Stimulus.register("data-updater", DataUpdaterController);
Stimulus.register("components", ComponentsController);
Stimulus.register("table-sorter", TableSorterController);
Stimulus.register("horizontal-bar-chart", HorizontalBarChartController);
Stimulus.register("timeline-line-chart", TimelineLineChartController);
Stimulus.register("response-time-chart", ResponseTimeChartController);
Stimulus.register("channel-backlog", ChannelBacklogController);
Stimulus.register("channel-click-up", ChannelClickUpController);
Stimulus.register("channel-click-up-chat", ChannelClickUpChatController);
Stimulus.register("css-updater", CssUpdaterController);
Stimulus.register("notice-pager", NoticePagerController);
Stimulus.register("merge-modal", MergeModalController);
Stimulus.register("auto-modal", AutoModalController);
Stimulus.register("fault-handsfree", FaultHandsfree);
Stimulus.register("site-handsfree", SiteHandsfree);
Stimulus.register("docs-toggle", DocsToggleController);
Stimulus.register("payment-checker", PaymentCheckerController);
Stimulus.register("channel-form", ChannelFormController);
Stimulus.register("unsaved-changes", UnsavedChangesController);
Stimulus.register("filter-elements", FilterElementsController);
Stimulus.register("visible-if", VisibleIfController);
Stimulus.register("searchable-list", SearchableListController);
Stimulus.register("source-code", SourceCodeController);
Stimulus.register("dismissible", DismissibleController);
Stimulus.register("bulk-actions", BulkActionsController);
Stimulus.register("mention", MentionController);
Stimulus.register("parameters-popover", ParametersPopoverController);
Stimulus.register("source-editor-modal", SourceEditorModalController);

export { Stimulus };
